import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import { withNamespaces } from 'react-i18next'
import i18next from 'i18next'
import ListRequest from './ListRequest'
import CalendarRequest from './CalendarRequest'
import { getAccessTab } from '@utils/menuHelper';
import * as keyMenu from '@scripts/KeyMenu';

function TabPanelRequest(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanelRequest.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function ScrollableTabsButtonForce({ t }) {
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [index, setIndex] = useState(0);
    const [hasApprovalCentral, setHasApprovalCentral] = useState(false);
    const [approvalRequestCalendar, setHasApprovalRequestCalendar] = useState(false);

    useEffect(() => {
        validateAccessTab();
    });

    const validateAccessTab = () => {
        const isTabApprovalCentral = getAccessTab(keyMenu.TAB_SUP_APPROVALCENTRAL);
        const isTabApprovalRequestCalendar = getAccessTab(keyMenu.TAB_SUP_REQUESTCALENDAR);
        setHasApprovalCentral(isTabApprovalCentral);
        setHasApprovalRequestCalendar(isTabApprovalRequestCalendar);
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const approvalClick = () => {
        setIndex(0);
    }

    const calendarClick = () => {
        setIndex(1);
    }

    return (
        <React.Fragment>
            <div data-id="headerRequest" className={classes.root}>
                <AppBar position="static" color="default" id="appBarTitle">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        {hasApprovalCentral && <Tab className={"TabPageButton"} label={i18next.t('approvalCentral:tabPanel.approval')} {...a11yProps(0)} onClick={approvalClick} />}
                        {approvalRequestCalendar && <Tab className={"TabPageButton"} label={t('approvalCentral:tabPanel.calendar')} {...a11yProps(1)} onClick={calendarClick} />}
                    </Tabs>
                </AppBar>
            </div>
            {hasApprovalCentral && index == 0 && <ListRequest />}
            {approvalRequestCalendar && index == 1 && <CalendarRequest />}
        </React.Fragment>
    );
}

export default withNamespaces(['approvalCentral'], { wait: true })(ScrollableTabsButtonForce);